import React, { useEffect, useRef, useState } from 'react';
import { FeetBoneIcon, FootPressureIcon, GCodeObjectExportIcon, LowpolyExportIcon, ShoeIcon, SlipperIcon, HighHeelIcon, Foot3DIcon } from '../Iconify/Iconify'

import logo from '../../assets/logo.png';
import DatabaseIcon from '@mui/icons-material/Storage';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import TemplateIcon from '@mui/icons-material/InsertDriveFile';
import ScanIcon from '@mui/icons-material/QrCodeScanner';
import AlignIcon from '@mui/icons-material/GridOn';
import PrintIcon from '@mui/icons-material/Print';
import OutputIcon from '@mui/icons-material/Output';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DatabasePanel from '../Modals/DatabaseModal/DatabasePanel';
import SaveTemplatePanel from '../Modals/SaveTemplateModal/SaveTemplatePanel';
import LoadTemplatePanel from '../Modals/LoadTemplateModal/LoadTemplatePanel';
import ScanPanel from 'Scan/ScanPanel';
import LoadWBCTPanel from 'components/Modals/LoadWBCTModal/LoadWBCTPanel';
import PatientDetailPanel from 'components/Modals/PatientModal/PatientDetailPanel';
import FootMeshPanel from 'components/Modals/FootMeshModal/FootMeshPanel';
import './Menu.css'
import SaveAsRoundedIcon from '@mui/icons-material/SaveAsRounded';
import ExportGCodeIcon from '@mui/icons-material/Timeline';
import ExportInsoleIcon from '@mui/icons-material/ViewInAr';
import { saveGCodeToFile, exportSTL } from 'Utils/ViewerUtils';

import { useViewerStore } from 'context/ViewerContext';
import { useFootMeshStore } from 'context/FootMeshContext';
import { useSelectedDesignStore } from 'context/SelectedDesignContext';
import { useDesignStore } from 'context/DesignContext';
import { scheduleAutosave } from 'components/Viewer3d/SaveManager';
import { useNavigate } from 'react-router-dom';
import { useApi } from "context/ApiProvider";
import RondomScanViewer from 'Scan/RondomScanViewer';
import toast from 'react-hot-toast';
import { SendDesignToHubTask, sendGcodeTextDto, sendGcodeWithUI, UpdateHubPrintTask, UpdateUserPrintRequestCount } from 'services/Printerservice';
import { useAuth } from 'context/AuthContext';
import { canEditDesign, canUseDevelopmentExports, canUseDevelopmentUi } from 'auth/permissions';
import SubmitPrintDialog from 'components/Dialog/SubmitPrintDialog';
import { LOCAL_STORAGE_KEYS } from 'components/Viewer3d/consts';
import { ConditionSide } from 'models/Insole';
import { PrinterType } from "Printers/PrinterFactory";
import { useLoadingComponentStore } from 'context/LoadingContext';
import { HubConnectionBuilder } from "@microsoft/signalr";
import { GetBones } from 'services/WBCTService';
import { isScanHardwareUnsupportedDevice, SCAN_HARDWARE_UNSUPPORTED_TOAST } from 'Utils/MediaQueryUtils';
import { showAlertDialog } from 'components/Dialog/dialog';
import { prepareGCode } from 'services/GCodeService';
import { Color, Mesh } from 'three';
import { OBJExporter } from 'three/examples/jsm/exporters/OBJExporter.js';
import { DesignCategory } from 'models/InsoleDesign';


interface ToolbarProps {
  toolbarRef?: React.RefObject<HTMLDivElement>;
}

const Toolbar: React.FC<ToolbarProps> = ({ toolbarRef }) => {
  const toolbarWrapperRef = useRef<HTMLDivElement | null>(null);
  const [isOutputDropdownOpen, setOutputDropdownOpen] = useState(false);
  const [isImportDropdownOpen, setImportDropdownOpen] = useState(false);
  const [isCategoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const [isAlignDropdownOpen, setAlignDropdownOpen] = useState(false);
  const [isDatabaseOpen, setIsDatabaseOpen] = useState(false);
  const [category, setCategory] = useState('Insole');
  const [categoryIcon, setCategoryIcon] = useState(<ShoeIcon />);
  const [isSaveTemplatePanelOpen, setSaveTemplatePanelOpen] = useState(false);
  const [isLoadTemplatePanelOpen, setLoadTemplatePanelOpen] = useState(false);
  const [isPatientOpen, setIsPatientOpen] = useState(false);
  const [isScanOpen, setIsScanOpen] = useState(false);
  const [isWbctOpen, setIsWbctOpen] = useState(false);
  const [isFootMeshOpen, setIsFootMeshOpen] = useState(false);
  const [isRondomOpen, setIsRondomOpen] = useState(false);
  const [isPrintDialogOpen, setIsPrintDialogOpen] = useState(false);
  const [isAlignEnabled, setIsAlignEnabled] = useState(false);
  const [isPatientInfoEnabled, setIsPatientInfoEnabled] = useState(false);
  const [isLoadTemplateEnabled, setLoadTemplateEnabled] = useState(false);
  const [isLoadWBCTEnabled, setLoadWBCTEnabled] = useState(false);
  const [isFootMeshEnabled, setFootMeshEnabled] = useState(false);
  const [isPressureScanEnabled, setPressureScanEnabled] = useState(false);
  const importPanelTimeoutRef = useRef<number | null>(null);
  const [designTitle, setDesignTitle] = useState('');
  const insoleDesign = useDesignStore((state) => state.insoleDesign);
  const designLoaded = useDesignStore((state) => state.designLoaded);
  const setDesignName = useDesignStore((state) => state.setDesignName);
  const editableRef = useRef<HTMLDivElement | null>(null);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const dropdownImportRef = useRef<HTMLDivElement | null>(null);
  const dropdownCategoryRef = useRef<HTMLDivElement | null>(null);
  const dropdownAlignRef = useRef<HTMLDivElement | null>(null);
  const hasFootMesh = useFootMeshStore((state) => state.rightFoot !== null || state.leftFoot !== null);
  const isAlignFootActive = useViewerStore((state) => state.alignFoot);
  const navigate = useNavigate();
  const closeToolboxMenus = () => document.dispatchEvent(new Event('toolbox:close'));
  const api = useApi();
  const gcodeReady = useDesignStore((state) => state.GcodeReady);
  const coloringMode = useViewerStore((state) => state.coloring);
  const { user, isExhibition } = useAuth();
  const canUseDevTools = canUseDevelopmentUi(user, isExhibition);
  const canUseDevExports = canUseDevelopmentExports(user);
  const [isSandalBtnEnabled, setIsSandalBtnEnabled] = useState(false);

  const SendToHubPrint = async () => {
    await SendDesignToHubTask(api, useSelectedDesignStore.getState().designId);
  }

  const handleModelClick = (model: string) => {
    updateCategoryItem(model);
    const designCat = model as DesignCategory;
    const event = new CustomEvent('updateCategoryState', { detail: { state: designCat } });
    document.dispatchEvent(event);
  };

  const updateCategoryItem = (model: string) => {
    setCategory(model);
    if (model == 'HighHeel')
      setCategoryIcon(<HighHeelIcon />);
    else if (model == 'Sandal')
      setCategoryIcon(<SlipperIcon />);
    else
      setCategoryIcon(<ShoeIcon />);
  }

  const handlePrintAccept = async (shouldPrintRightSide: boolean, shouldPrintLeftSide: boolean) => {
    if (user && !user.isAdmin && user?.group?.IsHub) {
      await SendToHubPrint();
      await UpdateUserPrintRequestCount(api, user.id, (user?.printRequestCount ?? 0) + 1);
      setIsPrintDialogOpen(false);
      toast.success('Your design has been sent to the admin for printing.', { duration: 5000 });
      return;
    }

    setIsPrintDialogOpen(false);
    const storedDefaultPrinters: any[] = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DEFAULT_PRINTERS) ?? '[]');
    var pLeft: any | null = null;
    var pRight: any | null = null;
    if (storedDefaultPrinters && storedDefaultPrinters.length > 0) {
      pLeft = storedDefaultPrinters.find(p => p.defaultPrinter === ConditionSide.left || p.defaultPrinter === ConditionSide.both) ?? null
      pRight = storedDefaultPrinters.find(p => p.defaultPrinter === ConditionSide.right || p.defaultPrinter === ConditionSide.both) ?? null
    }
    const textRight = insoleDesign?.insoles[0].gcodeText;
    const gcodesInputDto: sendGcodeTextDto[] = [];
    if (shouldPrintRightSide && textRight && pRight?.ip) {
      const rightGcodesInputDto: sendGcodeTextDto = {
        printerType: pRight.settingName as PrinterType,
        printerIp: pRight.ip,
        gcodeTitle: `${designTitle}_right`,
        gcodeText: textRight,
      };
      gcodesInputDto.push(rightGcodesInputDto);
    }
    const textLeft = insoleDesign?.insoles[1].gcodeText;
    if (shouldPrintLeftSide && textLeft && pLeft?.ip) {
      const leftGcodesInputDto: sendGcodeTextDto = {
        printerType: pLeft.settingName as PrinterType,
        printerIp: pLeft.ip,
        gcodeTitle: `${designTitle}_left`,
        gcodeText: textLeft,
      };
      gcodesInputDto.push(leftGcodesInputDto);
    }
    if (gcodesInputDto.length > 0) {
      const printSuccessful = await sendGcodeWithUI(gcodesInputDto, api);
      if (printSuccessful && user?.isAdmin && user?.group?.IsHub) {
        const printTaskId = useSelectedDesignStore.getState().printTaskId;
        if (printTaskId) {
          UpdateHubPrintTask(api, printTaskId, true);
        }
      }
    }
  };



  const handlePrintCancel = () => {
    setIsPrintDialogOpen(false);
  }

  React.useEffect(() => {
    const onPrintConfirm = (event: Event) => {
      const detail = (event as CustomEvent<{ action?: string; foot?: string }>).detail || {};
      const action = String(detail.action || "").toLowerCase();
      if (action === "open") {
        setIsPrintDialogOpen(true);
        return;
      }
      if (action === "cancel") {
        handlePrintCancel();
        return;
      }
    };
    document.addEventListener("voice:printConfirm", onPrintConfirm as EventListener);
    return () => document.removeEventListener("voice:printConfirm", onPrintConfirm as EventListener);
  }, [api, user, insoleDesign, designTitle]);

  const handleBlur = (e: React.FocusEvent<HTMLDivElement>) => {
    const updatedText = (e.currentTarget.textContent || '').trim();
    if (updatedText === '') {
      // Revert to previous text
      if (editableRef.current) {
        editableRef.current.textContent = designTitle;
      }
      console.warn('Empty input is not allowed for design title. Reverted.');
      return;
    }
    if (designTitle != updatedText) {
      setDesignTitle(updatedText);
      setDesignName(updatedText);
      scheduleAutosave('New design title', { updateDesignInfo: true, now: true });
      // console.log("User finished editing (onBlur):", updatedText);
    }
  };

  useEffect(() => {
    setIsPatientInfoEnabled(currentUserHasEditAccess());
    setPressureScanEnabled(currentUserHasEditAccess());
    setLoadTemplateEnabled(currentUserHasEditAccess());
    setIsSandalBtnEnabled(currentUserHasEditAccess());
    setLoadWBCTEnabled(currentUserHasEditAccess());
    setFootMeshEnabled(currentUserHasEditAccess());
    setIsAlignEnabled(
      (insoleDesign?.pressureData || !useDesignStore.getState().RondomImageData.some(img => img == undefined)) &&
      !coloringMode &&
      currentUserHasEditAccess()
    );
    if (designLoaded == false || insoleDesign === null) return;

    updateCategoryItem(useDesignStore.getState().insoleDesign!.category.toString());
    setDesignTitle(insoleDesign.name);
  }, [designLoaded]);

  useEffect(() => {
    if (insoleDesign?.name) setDesignTitle(insoleDesign.name);
  }, [insoleDesign?.name]);

  useEffect(() => {
    return () => {
      if (importPanelTimeoutRef.current !== null) {
        clearTimeout(importPanelTimeoutRef.current);
      }
    }
  })

  useEffect(() => {
    if (insoleDesign === null) return;
    updateCategoryItem(useDesignStore.getState().insoleDesign!.category.toString());
  }, [useDesignStore.getState().insoleDesign?.category])

  const handleImportDataByUserGroup = () => {
    if (user?.group?.IsRondom) {
      handleRondomClick();
    } else {
      handleScanClick();
    }
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const clickedOutsideOutput =
        dropdownRef.current && !dropdownRef.current.contains(target);
      const clickedOutsideImport =
        dropdownImportRef.current && !dropdownImportRef.current.contains(target);
      const clickedOutsideCategory =
        dropdownCategoryRef.current && !dropdownCategoryRef.current.contains(target);
      const clickedOutsideAlign =
        dropdownAlignRef.current && !dropdownAlignRef.current.contains(target);

      if (isOutputDropdownOpen && clickedOutsideOutput) {
        setOutputDropdownOpen(false);
      }

      if (isImportDropdownOpen && clickedOutsideImport) {
        setImportDropdownOpen(false);
      }

      if (isCategoryDropdownOpen && clickedOutsideCategory) {
        setCategoryDropdownOpen(false);
      }

      if (isAlignDropdownOpen && clickedOutsideAlign) {
        setAlignDropdownOpen(false);
      }
    };

    if (isOutputDropdownOpen || isImportDropdownOpen || isCategoryDropdownOpen || isAlignDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOutputDropdownOpen, isImportDropdownOpen, isCategoryDropdownOpen, isAlignDropdownOpen]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (!editableRef.current) return;

      if (!editableRef.current.contains(e.target as Node)) {
        editableRef.current.blur();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      return document.removeEventListener('mousedown', handleClickOutside);
    }
  }, []);


  useEffect(() => {
    setIsPrintDialogOpen(gcodeReady);
  }, [gcodeReady]);

  useEffect(() => {
    const closeAllToolbarDialogs = (keep?: string) => {
      if (keep !== "database") setIsDatabaseOpen(false);
      if (keep !== "patient") setIsPatientOpen(false);
      if (keep !== "scan") {
        setIsScanOpen(false);
        setIsRondomOpen(false);
      }
      if (keep !== "wbct") setIsWbctOpen(false);
      if (keep !== "footMesh") setIsFootMeshOpen(false);
      if (keep !== "loadTemplate") setLoadTemplatePanelOpen(false);
      if (keep !== "saveTemplate") setSaveTemplatePanelOpen(false);
      if (keep !== "saveMenu") setOutputDropdownOpen(false);
      setImportDropdownOpen(false);
      setCategoryDropdownOpen(false);
      setAlignDropdownOpen(false);
      if (keep !== "print") setIsPrintDialogOpen(false);
    };
    const onOpenDatabase = () => {
      closeToolboxMenus();
      setIsDatabaseOpen(true);
    };
    const onOpenPatient = (event?: Event) => {
      const detail = (event as CustomEvent)?.detail || {};
      if (detail.close || detail.create) {
        setIsPatientOpen(false);
        return;
      }
      closeToolboxMenus();
      setIsPatientOpen(true);
    };
    const onOpenScan = (event: Event) => {
      const type = (event as CustomEvent).detail?.type || "pressure";
      closeToolboxMenus();
      if ((type === "wbct" || type === "pressure") && isScanHardwareUnsupportedDevice()) {
        toast.error(SCAN_HARDWARE_UNSUPPORTED_TOAST, { duration: 8000 });
        return;
      }
      if (type === "wbct") void handleLoadWBCTClick();
      else if (type === "rondom" || user?.group?.IsRondom) handleRondomClick();
      else handleScanClick();
    };
    const onVoiceWbct = async () => {
      if (isScanHardwareUnsupportedDevice()) {
        document.dispatchEvent(new CustomEvent("voice:wbctScanDone", {
          detail: {
            ok: false,
            installed: false,
            unsupported: true,
            message: "Pressure tests and WBCT are not available on this device. Tell the user to use a computer.",
          }
        }));
        return;
      }
      closeToolboxMenus();
      useLoadingComponentStore.getState().setVisibile(true);
      let installed = false;
      try {
        installed = await new Promise<boolean>((resolve) => {
          const BASE_API_URL: string = process.env.REACT_APP_API_URL!;
          const connection = new HubConnectionBuilder()
            .withUrl(`${BASE_API_URL}/wbctHub`, { withCredentials: true })
            .build();
          let settled = false;
          const finish = (ok: boolean) => {
            if (settled) return;
            settled = true;
            window.clearTimeout(timer);
            void connection.stop();
            resolve(ok);
          };
          const timer = window.setTimeout(() => finish(false), 8000);
          const currentDesignId = useSelectedDesignStore.getState().designId;
          connection.on("CalculationStarted", (designId: number) => {
            if (currentDesignId === designId) finish(true);
          });
          connection.on("CalculationFinished", (designId: number) => {
            if (currentDesignId === designId) finish(true);
          });
          void connection.start()
            .then(() => { void openDesktopApp(); })
            .catch(() => finish(false));
        });
      } catch {
        installed = false;
      }
      useLoadingComponentStore.getState().setVisibile(false);
      if (!installed) {
        document.dispatchEvent(new CustomEvent("voice:wbctScanDone", {
          detail: {
            ok: false,
            installed: false,
            message: "The T-Soles desktop application is not installed. Tell the user they must install that software first, then try WBCT again.",
          }
        }));
        void showNotInstalledModal();
        return;
      }
      setIsWbctOpen(true);
      document.dispatchEvent(new CustomEvent("voice:wbctScanDone", {
        detail: {
          ok: true,
          installed: true,
          message: "WBCT window is open and the desktop software is available. Tell the user to load the data manually in that window. Do not say the scan is finished.",
        }
      }));
    };
    const onOpenTemplate = () => {
      closeToolboxMenus();
      setLoadTemplatePanelOpen(true);
    };
    const onOpenSave = () => {
      closeToolboxMenus();
      setOutputDropdownOpen(true);
    };
    const onExport = (event: Event) => {
      const format = (event as CustomEvent).detail?.format;
      if (format === "insoles") handleExportInsolesClick();
      else if (format === "gcode") handleExportGCodeClick();
      else if (format === "lowpoly") handleExportLowpolyClick();
      else if (format === "gcodeObject") handleExportGCodeObjectClick();
    };
    const onSaveTemplate = () => {
      closeToolboxMenus();
      setSaveTemplatePanelOpen(true);
    };
    const onClosePanels = (event: Event) => {
      const keep = (event as CustomEvent).detail?.keep;
      closeAllToolbarDialogs(keep);
    };
    const onGenerate = () => {
      void handlePrapareGCodeClick();
    };
    const onCategoryLabel = (event: Event) => {
      const label = (event as CustomEvent).detail?.label;
      if (label) updateCategoryItem(label);
    };
    document.addEventListener("voice:openDatabase", onOpenDatabase);
    document.addEventListener("voice:openPatient", onOpenPatient);
    document.addEventListener("voice:openScan", onOpenScan as EventListener);
    document.addEventListener("voice:wbctScan", onVoiceWbct as EventListener);
    document.addEventListener("voice:openLoadTemplate", onOpenTemplate);
    document.addEventListener("voice:openSaveMenu", onOpenSave);
    document.addEventListener("voice:export", onExport as EventListener);
    document.addEventListener("voice:openSaveTemplate", onSaveTemplate);
    document.addEventListener("voice:closePanels", onClosePanels as EventListener);
    document.addEventListener("voice:generateGcode", onGenerate);
    document.addEventListener("voice:setCategoryLabel", onCategoryLabel as EventListener);
    return () => {
      document.removeEventListener("voice:openDatabase", onOpenDatabase);
      document.removeEventListener("voice:openPatient", onOpenPatient);
      document.removeEventListener("voice:openScan", onOpenScan as EventListener);
      document.removeEventListener("voice:wbctScan", onVoiceWbct as EventListener);
      document.removeEventListener("voice:openLoadTemplate", onOpenTemplate);
      document.removeEventListener("voice:openSaveMenu", onOpenSave);
      document.removeEventListener("voice:export", onExport as EventListener);
      document.removeEventListener("voice:openSaveTemplate", onSaveTemplate);
      document.removeEventListener("voice:closePanels", onClosePanels as EventListener);
      document.removeEventListener("voice:generateGcode", onGenerate);
      document.removeEventListener("voice:setCategoryLabel", onCategoryLabel as EventListener);
    };
  }, [api, user, insoleDesign]);

  useEffect(() => {
    if (
      (insoleDesign?.pressureData || !useDesignStore.getState().RondomImageData.some(img => img == undefined)) &&
      !coloringMode &&
      currentUserHasEditAccess()
    ) {
      setIsAlignEnabled(true);
    } else {
      setIsAlignEnabled(false);
    }
  }, [insoleDesign?.pressureData, useDesignStore.getState().RondomImageData, coloringMode]);

  async function showNotInstalledModal() {
    useLoadingComponentStore.getState().setVisibile(false);

    const result = await showAlertDialog({
      title: "Application Not Found",
      description:
        "Please install the desktop application to continue.",
      agreeText: "Download",
      disagreeText: "Cancel",
    });

    if (result) {
      // window.open("URL_DL_APP", "_blank");
      window.open("https://design.t-soles.com/downloads/T-SolesInstaller.msi", "_blank")
    }
  }
  const connectWBCTHub = async () => {
    const BASE_API_URL: string = process.env.REACT_APP_API_URL!;
    const connection = new HubConnectionBuilder()
      .withUrl(`${BASE_API_URL}/wbctHub`, {
        accessTokenFactory: () => localStorage.getItem('accessToken') ?? '',
        withCredentials: true
      })
      .withAutomaticReconnect([0, 2000, 10000, 30000])
      .build();

    let started = false;
    const checkAppInstalledTimer = setTimeout(() => {
      if (!started) {
        useLoadingComponentStore.getState().setVisibile(false);
        showNotInstalledModal();
        connection.stop();
      }
    }, 10000);

    const currentDesignId = useSelectedDesignStore.getState().designId;
    const currentDesign = useDesignStore.getState().insoleDesign;
    connection.on("CalculationFinished", async function (designId: number, status: string) {
      if (currentDesignId === designId) {
        if (status.toLocaleLowerCase() == "calculationcanceled") {
          toast.error("Importing WBCT canceled by user");
        } else if (status.toLocaleLowerCase() == "calculationfailed") {
          toast.error("Segmentation failed");
        } else {
          await GetBones(api, "All", designId, currentDesign, true);
          const event = new CustomEvent('newWBCTScan', { detail: { status: true } });
          document.dispatchEvent(event);
        }
      }
      useLoadingComponentStore.getState().setVisibile(false);
      connection.stop();
    });

    connection.on("CalculationStarted", async function (designId: number) {
      if (currentDesignId === designId) {
        started = true;
        clearTimeout(checkAppInstalledTimer);
      }
    });

    connection.onreconnected(() => {
      //console.log("SignalR reconnected");
    })

    await connection.start();
    setImportDropdownOpen(false);
  }

  const handleDatabaseClick = () => {
    closeToolboxMenus();
    setIsDatabaseOpen(true);
  };

  const handleAdminClick = () => {
    navigate('/admin')
  };

  const handlePatClick = () => {
    closeToolboxMenus();
    setIsPatientOpen(true);
  };

  const handleDatabaseClose = () => {
    setIsDatabaseOpen(false);
  };
  const handlePatClose = () => {
    setIsPatientOpen(false);
  };

  const handleScanClick = () => {
    if (isScanHardwareUnsupportedDevice()) {
      closeToolboxMenus();
      toast.error(SCAN_HARDWARE_UNSUPPORTED_TOAST, { duration: 8000 });
      return;
    }
    closeToolboxMenus();
    setIsScanOpen(true);
  };

  const handleScanClose = () => {
    setIsScanOpen(false);
  };

  const handleRondomClick = () => {
    closeToolboxMenus();
    setIsRondomOpen(true);
  }

  const handleRondomClose = () => {
    setIsRondomOpen(false);
  }

  const handleAlignPressureClick = () => {
    const design = useDesignStore.getState().insoleDesign;
    if (!design) return;
    if (!design.pressureData && useDesignStore.getState().RondomImageData.some(img => img == undefined)) {
      toast.error('Your design has no pressure.');
      return;
    }
    if (useViewerStore.getState().alignPressure) {
      useViewerStore.getState().setLiveMode(useViewerStore.getState().oldLiveMode);
    } else {
      useViewerStore.getState().setOldLiveMode(useViewerStore.getState().liveMode);
      useViewerStore.getState().setLiveMode(useViewerStore.getState().alignPressure);
    }
    useViewerStore.getState().toggleAlignPressure();
  }

  const handleAlignDropDownClick = () => {
    closeToolboxMenus();
    setAlignDropdownOpen(!isAlignDropdownOpen);
  };

  const handleAlignPressureItemClick = () => {
    setAlignDropdownOpen(false);
    handleAlignPressureClick();
  };

  const handleAlignFootClick = () => {
    setAlignDropdownOpen(false);
    useViewerStore.getState().setAlignFoot(!useViewerStore.getState().alignFoot);
  };

  const handlePrapareGCodeClick = async () => {
    closeToolboxMenus();

    const oldLiveMode = useViewerStore.getState().liveMode;
    useViewerStore.getState().setLiveMode(false);

    if (gcodeReady)
      setIsPrintDialogOpen(gcodeReady);
    else
      await prepareGCode(api, user, insoleDesign);
    useViewerStore.getState().setLiveMode(oldLiveMode);
  };

  const handleSaveTemplateClick = () => {
    closeToolboxMenus();
    setOutputDropdownOpen(false);
    setSaveTemplatePanelOpen(true);
  };

  const handleSaveTemplateClose = () => {
    setSaveTemplatePanelOpen(false);
  };

  const handleLoadTemplateClick = () => {
    closeToolboxMenus();
    setLoadTemplatePanelOpen(true);
  };

  const handleLoadWBCTClick = async () => {
    if (isScanHardwareUnsupportedDevice()) {
      closeToolboxMenus();
      toast.error(SCAN_HARDWARE_UNSUPPORTED_TOAST, { duration: 8000 });
      return;
    }
    useLoadingComponentStore.getState().setVisibile(true);
    openDesktopApp();
    await connectWBCTHub();


    // const currentDesignId = useSelectedDesignStore.getState().designId;
    // const currentDesign = useDesignStore.getState().insoleDesign;
    // await GetBones(api, "All", currentDesignId, currentDesign, true);
    // const event = new CustomEvent('newWBCTScan', { detail: { status: true } });
    // document.dispatchEvent(event);

  }

  const handleFootMeshClick = () => {
    closeToolboxMenus();
    setImportDropdownOpen(false);
    setIsFootMeshOpen(true);
  };

  const handleLoadTemplateClose = () => {
    setLoadTemplatePanelOpen(false);
  };

  const handleExportLowpolyClick = () => {
    closeToolboxMenus();

    insoleDesign?.insoles.forEach((insole, index) => {
      if (insole.lowpolyBufferGeometry) {
        const lowpolyMesh = new Mesh(insole.lowpolyBufferGeometry);
        exportSTL(lowpolyMesh, `${insoleDesign.name}_Lowpoly_${index === 0 ? 'Right' : 'Left'}`);
      }
    });
  };

  const handleExportInsolesClick = () => {
    closeToolboxMenus();

    insoleDesign?.insoles.forEach((insole, index) => {
      if (insole.mainMesh) {
        exportSTL(insole.mainMesh, `${insoleDesign.name}_${index === 0 ? 'Right' : 'Left'}`);
      }
    });
  };

  const handleExportGCodeObjectClick = () => {
    closeToolboxMenus();

    const gcodes = useDesignStore.getState().getGCode();
    if (!gcodes?.length) return;

    const exporter = new OBJExporter();
    gcodes.forEach((gcode, index) => {
      if (gcode) {
        const vertexColors: string[] = [];
        const color = new Color();

        gcode.traverse((child) => {
          if (!(child instanceof Mesh)) return;

          const positions = child.geometry.getAttribute('position');
          const colors = child.geometry.getAttribute('color');
          if (!positions) return;

          for (let vertexIndex = 0; vertexIndex < positions.count; vertexIndex++) {
            if (colors && vertexIndex < colors.count) {
              color.fromBufferAttribute(colors, vertexIndex).convertLinearToSRGB();
            } else {
              color.set(0xffffff);
            }
            vertexColors.push(`${color.r} ${color.g} ${color.b}`);
          }
        });

        let vertexIndex = 0;
        const obj = exporter.parse(gcode)
          .split('\n')
          .map((line) => line.startsWith('v ')
            ? `${line} ${vertexColors[vertexIndex++] ?? '1 1 1'}`
            : line)
          .join('\n');
        const designName = insoleDesign?.name ?? 'gcode';
        saveGCodeToFile(
          obj,
          `${designName}_GCode_${index === 0 ? 'Right' : 'Left'}.obj`,
          'text/plain'
        );
      }
    });
  };

  const handleExportGCodeClick = () => {
    closeToolboxMenus();

    insoleDesign?.insoles.forEach((insole, index) => {
      if (insole.gcodeText) {
        saveGCodeToFile(insole.gcodeText, `${insoleDesign.name}_${index === 0 ? 'Right' : 'Left'}.gcode`);
      }
    });
  };

  const currentUserHasEditAccess = (): boolean => {
    return canEditDesign(user, useSelectedDesignStore.getState().createdBy?.id);
  }

  const openDesktopApp = async () => {
    const token = encodeURIComponent(localStorage.getItem("accessToken")!);
    const designId = useSelectedDesignStore.getState().designId;

    const url =
      `T-Soles://run?designId=${designId}&token=${token}`

    window.location.href = url
  };

  const handleImportDropDownClick = () => {
    if (isImportDropdownOpen) {
      setImportDropdownOpen(false)
    } else {
      setImportDropdownOpen(true)
    }
  }

  const handleCategoryDropDownClick = () => {
    closeToolboxMenus();

    if (isCategoryDropdownOpen) {
      setCategoryDropdownOpen(false)
    } else {
      setCategoryDropdownOpen(true)
    }
  }

  return (
    <>
      <div className="toolbar-wrapper" ref={toolbarWrapperRef}>
        <div className="toolbar" ref={toolbarRef}>
          <div className="toolbar-left">
            <div className="toolbar-group">
              <div className="toolbar-center">
              </div>
              <div className="toolbar-item">
                {
                  user?.isAdmin === false ?
                    <>
                      <button className="toolbar-button" data-tour-id="database" onClick={handleDatabaseClick}>
                        <DatabaseIcon />
                      </button>
                      <span className="toolbar-label">Database</span>
                    </>
                    :
                    <>
                      <button className="toolbar-button" onClick={handleAdminClick}>
                        <AdminPanelSettingsIcon />
                      </button>
                      <span className="toolbar-label">Admin Panel</span>
                    </>
                }
              </div>
              <div className="toolbar-item">
                <button className="toolbar-button" data-tour-id="patient" onClick={handlePatClick} disabled={!isPatientInfoEnabled}>
                  <AccountCircleIcon />
                </button>
                <span className="toolbar-label">Patient Info</span>
              </div>
              {/* <div className="toolbar-item">
                <button className="toolbar-button" data-tour-id="scan" onClick={handleScanClick}>
                  <ScanIcon />
                </button>
                <span className="toolbar-label">Load Scan</span>
              </div> */}
            </div>
          </div> { /* toolbar-left end*/}
          <div className="toolbar-group">
            <div className="toolbar-item" style={{ position: 'relative' }}>
              <button className="toolbar-button" data-tour-id="pressure-import" title="Pressure Scan" onClick={handleImportDropDownClick} disabled={!isPressureScanEnabled}>
                <ScanIcon />
              </button>
              <span className="toolbar-label">Load Scan</span>
              {isImportDropdownOpen && (
                <div className="output-dropdown" ref={dropdownImportRef}>
                  <div className="dropdown-toolbar-group">
                    <div className="dropdown-toolbar-item">
                      <button className="toolbar-button" data-tour-id="tsoles-import" title="TSoles" onClick={handleImportDataByUserGroup} disabled={!isPressureScanEnabled}>
                        {/* <small style={{ fontSize: '2.7em', color: 'var(--toolbar-button-text)', textAlign: 'center' }}>T</small> */}
                        <FootPressureIcon />
                      </button>
                      <span className="toolbar-label">Pressure</span>
                    </div>
                    <div className="dropdown-toolbar-item">
                      <button className="toolbar-button" data-tour-id="wbct" title="WBCT" onClick={handleLoadWBCTClick} disabled={!isLoadWBCTEnabled}>
                        <FeetBoneIcon />
                      </button>
                      <span className="toolbar-label">WBCT</span>
                    </div>
                    {canUseDevExports && (
                      <div className="dropdown-toolbar-item">
                        <button className="toolbar-button" data-tour-id="foot-mesh" title="Import Foot Mesh (OBJ / STL)" onClick={handleFootMeshClick} disabled={!isFootMeshEnabled}>
                          <Foot3DIcon />
                        </button>
                        <span className="toolbar-label">3D Foot</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="toolbar-item">
              <button className="toolbar-button" data-tour-id="load-template" onClick={handleLoadTemplateClick} disabled={!isLoadTemplateEnabled}>
                <TemplateIcon />
              </button>
              <span className="toolbar-label">Load Template</span>
            </div>
          </div> {/* toolbar-group end */}
          <div style={{ position: "relative", width: "fit-content" }}>
            <img src={logo} alt="T-Soles Logo" className="toolbar-logo" />
            <div
              className='design-title'
              ref={editableRef}
              tabIndex={0}
              contentEditable
              suppressContentEditableWarning
              onBlurCapture={handleBlur}
            >
              {designTitle}
            </div>
          </div> { /* logo and title div end */}
          <div className="toolbar-right">
            <div className="toolbar-group">
              <div className="toolbar-item" style={{ position: 'relative' }}>
                <button className="toolbar-button" data-tour-id="align-pressure" onClick={handleAlignDropDownClick} disabled={!isAlignEnabled && !(hasFootMesh && isFootMeshEnabled)}>
                  <AlignIcon />
                </button>
                <span className="toolbar-label">Align</span>
                {isAlignDropdownOpen && (
                  <div className="output-dropdown" ref={dropdownAlignRef}>
                    <div className="dropdown-toolbar-group">
                      <div className="dropdown-toolbar-item">
                        <button className="toolbar-button" title="Align Pressure" onClick={handleAlignPressureItemClick} disabled={!isAlignEnabled}>
                          <FootPressureIcon />
                        </button>
                        <span className="toolbar-label">Pressure</span>
                      </div>
                      {canUseDevExports && (
                        <div className="dropdown-toolbar-item">
                          <button className="toolbar-button" title={isAlignFootActive ? 'Stop aligning 3D foot (discard changes)' : 'Align 3D Foot'} onClick={handleAlignFootClick} disabled={!(hasFootMesh && isFootMeshEnabled)}>
                            <Foot3DIcon />
                          </button>
                          <span className="toolbar-label">{isAlignFootActive ? 'Stop 3D Foot' : '3D Foot'}</span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="toolbar-item" style={{ position: 'relative' }}>
                <button className="toolbar-button" data-tour-id="output" onClick={() => setOutputDropdownOpen(!isOutputDropdownOpen)}>
                  <OutputIcon />
                </button>
                <span className="toolbar-label">Save</span>
                {isOutputDropdownOpen && closeToolboxMenus() && (
                  <div className="output-dropdown" ref={dropdownRef}>
                    <div className='dropdown-toolbar-group'>
                      <div className="dropdown-toolbar-item">
                        <button className="toolbar-button" title="Export Insole" onClick={handleExportInsolesClick}>
                          <ExportInsoleIcon />
                        </button>
                        <span className="toolbar-label">Export Insoles</span>
                      </div>
                      <div className="dropdown-toolbar-item">
                        <button className="toolbar-button" title="Export G-Code" onClick={handleExportGCodeClick} disabled={useDesignStore.getState().gCodes?.length < 1}>
                          <ExportGCodeIcon />
                        </button>
                        <span className="toolbar-label">Export G-Code</span>
                      </div>
                    </div>
                    <div className='dropdown-toolbar-group'>
                      <div className="dropdown-toolbar-item">
                        <button className="toolbar-button" title="Save as Template" onClick={handleSaveTemplateClick}>
                          <SaveAsRoundedIcon />
                        </button>
                        <span className="toolbar-label">Save as Template</span>
                      </div>
                    </div>
                    {canUseDevExports && <div className='dropdown-toolbar-group'>
                      <div className="dropdown-toolbar-item">
                        <button className="toolbar-button" title="Export Lowpoly" onClick={handleExportLowpolyClick}>
                          <LowpolyExportIcon />
                        </button>
                        <span className="toolbar-label">Export Lowpoly</span>
                      </div>
                      <div className="dropdown-toolbar-item">
                        <button className="toolbar-button" title="Export G-Code Object" onClick={handleExportGCodeObjectClick} disabled={useDesignStore.getState().gCodes?.length < 1}>
                          <GCodeObjectExportIcon />
                        </button>
                        <span className="toolbar-label">Export G-Code Object</span>
                      </div>
                    </div>
                    }
                  </div>
                )}
              </div>
            </div>
            <div className="toolbar-group">
              {canUseDevTools && <div className="toolbar-item">
                <button className="toolbar-button"
                  data-tour-id="model-category" title={category}
                  onClick={handleCategoryDropDownClick}
                  disabled={!isSandalBtnEnabled}>
                  {categoryIcon}
                </button>
                <span className="toolbar-label">{category}</span>
                {isCategoryDropdownOpen && (
                  <div className="output-dropdown" ref={dropdownCategoryRef}>
                    <div className="dropdown-toolbar-group" style={{ flexDirection: 'row' }} >
                      <div className="dropdown-toolbar-item">
                        <button className="toolbar-button" title="Insole" onClick={e => handleModelClick('Insole')}>
                          <ShoeIcon />
                        </button>
                        <span className="toolbar-label">Insole</span>
                      </div>
                      <div className="dropdown-toolbar-item">
                        <button className="toolbar-button" title="Sandal" onClick={e => handleModelClick('Sandal')}>
                          <SlipperIcon />
                        </button>
                        <span className="toolbar-label">Sandal</span>
                      </div>
                      <div className="dropdown-toolbar-item">
                        <button className="toolbar-button" title="High Heel" onClick={e => handleModelClick('HighHeel')}>
                          <HighHeelIcon />
                        </button>
                        <span className="toolbar-label">High Heel</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              }
              <div className="toolbar-item">
                <button className="toolbar-button" data-tour-id="print" title="Print" onClick={handlePrapareGCodeClick} disabled={isPrintDialogOpen}>
                  <PrintIcon />
                </button>
                <span className="toolbar-label">Print</span>
              </div>
            </div>
          </div> { /* toolbar-right end */}
        </div> {/* toolbar end */}
      </div> {/* toolbar-wrapper end */}
      {!user?.isAdmin && <DatabasePanel isOpen={isDatabaseOpen} onCloseCallback={handleDatabaseClose} />}
      <PatientDetailPanel isOpen={isPatientOpen} onClose={handlePatClose} />
      <ScanPanel isOpen={isScanOpen} onClose={handleScanClose} />
      <LoadWBCTPanel isOpen={isWbctOpen} onClose={() => setIsWbctOpen(false)} />
      <FootMeshPanel isOpen={isFootMeshOpen} onClose={() => setIsFootMeshOpen(false)} />
      <RondomScanViewer isOpen={isRondomOpen} onClose={handleRondomClose} />
      <SaveTemplatePanel isOpen={isSaveTemplatePanelOpen} onClose={handleSaveTemplateClose} />
      <LoadTemplatePanel isOpen={isLoadTemplatePanelOpen} onClose={handleLoadTemplateClose} />
      <SubmitPrintDialog isOpen={isPrintDialogOpen} onAccept={handlePrintAccept} onCancel={handlePrintCancel} />
    </>
  );
};

export default Toolbar;
